import { Grid, Typography } from '@mui/material';
import ActionsBar from '../ActionsBar/ActionsBar';
import styles from './ResourcesActions.module.scss';

export default function ResourcesActions() {
    return (
        <ActionsBar>
            <Grid container justifyContent="flex-between" alignContent="center" className={styles.Wrapper}>
                <Grid item xs={6} container alignContent="center">
                    <Typography variant="h3" color="primary">Recursos</Typography>
                </Grid>
            </Grid>
        </ActionsBar>
    )
}

